import { matchPath } from "react-router";
import { appRoutes } from "@/app/router";
import { AppStore } from "@/store";
import { MDSCollectionIcon, MDSIconKind } from "@/mds";
import { AudioCaptureWaveForm } from "@/components/layout/components/audio-capture";
import { parseRoutingPathname } from "@/modules/routing/parsePathname";

export const getPathIcon = (path: string, store: AppStore): MDSIconKind | React.ReactNode => {
  const pathname = parseRoutingPathname(path);

  const noteIdMatch = matchPath(
    appRoutes.notesView({ params: { noteId: ":noteId" }, starPattern: true }),
    pathname
  );
  if (noteIdMatch?.params.noteId === store.audio.activeRecordingNoteId)
    return <AudioCaptureWaveForm associatedNoteId={store.audio.activeRecordingNoteId} />;

  const collectionIdMatch = matchPath(
    appRoutes.collectionsView({ params: { collectionId: ":collectionId" }, starPattern: true }),
    pathname
  );
  const collectionId = collectionIdMatch?.params.collectionId;
  if (collectionId) return <MDSCollectionIcon size={10} collectionId={collectionId} />;

  if (pathname.startsWith(appRoutes.search({}).path)) return MDSIconKind.Search;
  if (pathname.startsWith(appRoutes.agentSearch({}).path)) return MDSIconKind.Radar;
  if (pathname === appRoutes.notesList({}).path) return MDSIconKind.Notebook;
  if (pathname === appRoutes.collections({}).path) return MDSIconKind.Collection;
  if (pathname === appRoutes.templatesList({}).path) return MDSIconKind.Template;
  if (pathname.startsWith(appRoutes.integrations({}).path)) return MDSIconKind.BoltOutline;
  if (pathname.startsWith(appRoutes.settings({}).path)) return MDSIconKind.Settings;
  if (pathname === appRoutes.trash({}).path) return MDSIconKind.Trash;
  return null;
};
